// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ExcluirContaRouteImport } from './routes/excluir-conta'
import { Route as MetodoNookRouteImport } from './routes/metodo-nook'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as SuporteRouteImport } from './routes/suporte'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as TrabalheConoscoRouteImport } from './routes/trabalhe-conosco'
import { Route as UnidadesIndexRouteImport } from './routes/unidades.index'
import { Route as UnidadesSlugRouteImport } from './routes/unidades.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ExcluirContaRoute = ExcluirContaRouteImport.update({
            id: '/excluir-conta',path: '/excluir-conta',getParentRoute: () => rootRouteImport
          })
const MetodoNookRoute = MetodoNookRouteImport.update({
            id: '/metodo-nook',path: '/metodo-nook',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const SuporteRoute = SuporteRouteImport.update({
            id: '/suporte',path: '/suporte',getParentRoute: () => rootRouteImport
          })
const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
            id: '/termos-de-uso',path: '/termos-de-uso',getParentRoute: () => rootRouteImport
          })
const TrabalheConoscoRoute = TrabalheConoscoRouteImport.update({
            id: '/trabalhe-conosco',path: '/trabalhe-conosco',getParentRoute: () => rootRouteImport
          })
const UnidadesIndexRoute = UnidadesIndexRouteImport.update({
            id: '/unidades/',path: '/unidades/',getParentRoute: () => rootRouteImport
          })
const UnidadesSlugRoute = UnidadesSlugRouteImport.update({
            id: '/unidades/$slug',path: '/unidades/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ExcluirContaRoute: ExcluirContaRoute,MetodoNookRoute: MetodoNookRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,SuporteRoute: SuporteRoute,TermosDeUsoRoute: TermosDeUsoRoute,TrabalheConoscoRoute: TrabalheConoscoRoute,UnidadesSlugRoute: UnidadesSlugRoute,UnidadesIndexRoute: UnidadesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)